angular.module('rjmNg.directives').directive "rjselect", [
  "$document"
  ($document) ->
    restrict: "E"
    templateUrl: "directive.rjselect.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      selectedOption: "="
      options: "="
      arrayByKey: "=?"
    controller: [
      () ->
        view = @

        view.isDropdownVisible = false

        view.toggleDropdown = () ->
          view.isDropdownVisible = !view.isDropdownVisible

        view.closeDropdown = () ->
          view.isDropdownVisible = false

        view.select = (option) ->
          view.selectedOption = option

        @$onInit = ->
          view.arrayByKey ?= false

        view
    ]
    link: (scope, element, attr, view) ->
      _clickOutsideRjpopover = (event) ->
        if view.isDropdownVisible and
          not (element[0] is event.target or
               element[0].contains(event.target))
                 view.closeDropdown()

      $document.on("click", _clickOutsideRjpopover)

      _cleanUp = () ->
        $document.off('click', _clickOutsideRjpopover)
        return

      scope.$on('$destroy', _cleanUp)
]
